import type { PageMeta } from '@brix/types'

export interface PageProps {
  id: string
  siteId: string
  title: string
  slug: string
  published: boolean
  isHome: boolean
  meta: PageMeta
  createdAt: Date
  updatedAt: Date
}

export class Page {
  readonly id: string
  readonly siteId: string
  readonly title: string
  readonly slug: string
  readonly published: boolean
  readonly isHome: boolean
  readonly meta: PageMeta
  readonly createdAt: Date
  readonly updatedAt: Date

  private constructor(props: PageProps) {
    this.id = props.id
    this.siteId = props.siteId
    this.title = props.title
    this.slug = props.slug
    this.published = props.published
    this.isHome = props.isHome
    this.meta = props.meta
    this.createdAt = props.createdAt
    this.updatedAt = props.updatedAt
  }

  static reconstitute(props: PageProps): Page {
    return new Page(props)
  }

  withPublished(published: boolean): Page {
    return new Page({ ...this, published })
  }

  withMeta(meta: Partial<PageMeta>): Page {
    return new Page({ ...this, meta: { ...this.meta, ...meta } })
  }
}
